"use client";

import { createListCollection } from "@chakra-ui/react";
import { useMemo } from "react";
import { type Target } from "@/generated/fastapi";
import { getTargetDisplayLabel } from "../utils/targetDisplay";

export default function useTargetOptions(targets?: Target[]) {
  return useMemo(() => {
    if (!targets?.length) {
      return createListCollection({ items: [] as Target[] });
    }

    return createListCollection({
      items: targets,
      itemToString: getTargetDisplayLabel,
      itemToValue: (item) => item.id as string,
    });
  }, [targets]);
}
